"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tariff = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const iconItemConfig_1 = require("./iconItemConfig");
exports.tariff = {
    title: 'Business',
    detailsConfig: [
        iconItemConfig_1.iconItemsConfig.meal,
        iconItemConfig_1.iconItemsConfig.briefcaseBusiness,
        iconItemConfig_1.iconItemsConfig.baggageBusiness,
        iconItemConfig_1.iconItemsConfig.fastlane,
        iconItemConfig_1.iconItemsConfig.priorityBoarding,
        iconItemConfig_1.iconItemsConfig['calendar-mark'],
    ],
    detailedDescription: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/PriceVariant/TariffConfig/business:DetailedDescription', description: 'Rate `business` detailed HTML description', defaultMessage: '<p>Business class offers passengers a luxurious travel experience with spacious seating and complimentary food and drinks. Passengers are entitled to two pieces of hand baggage and two pieces of baggage.</p><p>Besides the comforts provided on board, Business class also allows travelers to use exclusive fast lanes and priority boarding (where applicable).</p><p>All stated times are local times at the origin of departure.</p><p>The listed price is for one flight per adult person. Depending on the selected payment method, additional fees may apply.  Please be aware that prices are subject to change until the booking is confirmed.</p>', values: {
            p: (chunk) => react_1.default.createElement("p", null, chunk),
        } })),
};
//# sourceMappingURL=business.js.map